const VEHICLE_CAPABILITY_DEFINITIONS = [
    { id: "tail_lift", label: "Tail-lift", sortOrder: 10.0000 },
    { id: "pallet_truck", label: "Pallet truck", sortOrder: 20.0000 },
    { id: "load_blankets", label: "Load blankets", sortOrder: 30.0000 },
    { id: "load_restraints", label: "Load restraints", sortOrder: 40.0000 },
    { id: "moffett", label: "Moffett", sortOrder: 50.0000 },
    { id: "hiab", label: "HIAB", sortOrder: 60.0000 },
    { id: "loading_ramps", label: "Loading ramps", sortOrder: 70.0000 },
    { id: "side_loading", label: "Side loading", sortOrder: 80.0000 },
    { id: "sliding_roof", label: "Sliding roof", sortOrder: 90.0000 },
    { id: "temperature_controlled", label: "Temperature controlled", sortOrder: 100.0000 },
    { id: "adr_equipped", label: "ADR equipped", sortOrder: 110.0000 },
    { id: "vehicle_winch", label: "Vehicle winch", sortOrder: 120.0000 }
];
export const VEHICLE_CAPABILITIES = [...VEHICLE_CAPABILITY_DEFINITIONS].sort((left, right) => left.sortOrder - right.sortOrder);
export function emptyVehicleCapabilities() {
    return Object.fromEntries(VEHICLE_CAPABILITIES.map(capability => [capability.id, false]));
}
export function vehicleCapabilityLabel(id) {
    return VEHICLE_CAPABILITIES.find(capability => capability.id === id)?.label ?? id;
}
